import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { Users } from 'src/app/models/um/organization';
import { UserService } from 'src/app/services/user.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { Department } from 'src/app/models/common';
import { genderOptionsConstant } from 'src/app/constants/service.constants';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-support-users-view-modal',
  templateUrl: './support-users-view-modal.component.html',
  styleUrls: ['./support-users-view-modal.component.scss']
})
export class SupportUsersViewModalComponent implements OnInit {
  @Input() public Content: any;

  formFields;
  operations;
  isView = false;
  viewId = null;
  genderOptions = genderOptionsConstant;
  isautocode: boolean = false;
  MappedUserRoles: any[] = [];
  userForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    TITLE: new UntypedFormControl(null),
    EMAIL: new UntypedFormControl(null),
    Status: new UntypedFormControl(true),
    PHONE: new UntypedFormControl(null),
    ROLEID: new UntypedFormControl(null),
    DEPARTMENT_ID: new UntypedFormControl([]),
    IsAdmin:new UntypedFormControl(false)
  })
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  user: Users;
  fullname: string;
  departments: Department[] = [];
  lookups: any;
  users: any;

  constructor(
    private summaryService: UmSummaryService,
    private deptService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService,
  ) {

  }

  ngOnInit() {
    this.user = new Users();
    if (this.Content.content && this.Content.content.id) { // Edit mode
   
      this.summaryService.getUser(this.Content.content.id).subscribe((result) => {
     
        this.userForm.patchValue({
          ID: (result.ID),
          EMAIL: (result.EMAIL),
          TITLE:(result.TITLE),
          PHONE:(result.PHONE),
          DEPARTMENT_ID:[],
          ROLEID: "",
          Status: result.Status,
          IsAdmin:result.IsAdmin
        })
        if(result.DEPARTMENT_ID!=null && result.DEPARTMENT_ID!=undefined && result.DEPARTMENT_ID!="")
        {
          let dept=result.DEPARTMENT_ID.split(",");
          this.userForm.controls["DEPARTMENT_ID"].setValue(dept);
        }
       //  Role_Id: new UntypedFormControl(result.Role_Id),
        if (this.Content.heading === 'View') {
          setTimeout(() => {
            this.userForm.disable({ emitEvent: false });
          }, 100);
        }
        else if(this.Content.heading === 'Edit')
        {
          this.userForm.controls["EMAIL"].disable();
        }

        if(this.Content.heading === 'Edit' || this.Content.heading === 'View'){
          if(this.Content.content.IsAnalyticsConfig == true && this.Content.content.IsOrgaccinLogi == true && result.IS_USER_LINKED_WITH_LOGI == false){
            // this.commonservice.ValidationBanner("The analytics account is not created for the user " + result.TITLE + ". Please refresh the details to create an account");
            this.commonservice.ValidationBanner("User " + result.TITLE + " details saved successfully but the analytics account is not created has failed. Please refresh the details to create an account");
          }
        }

      });
    }
   

  }

  private getForm(): Users {

    const formModel = this.userForm.getRawValue();
    formModel.ROLEID ="";formModel.DEPARTMENT_ID="";
    let user = new Users();
    user = {
      ID: formModel.ID || '',
      CODE: '',
      USER_TYPE: '',
      EMAIL: formModel.EMAIL || '',
      TITLE: formModel.TITLE || '',
      FIRST_NAME: '',
      MIDDLE_NAME: '',
      LAST_NAME: '',
      SSN: '',
      GENDER: '',
      DESIGNATION: '',
      PHONE: formModel.PHONE || '',
      PHONE_EXT: 0,
      ALTERNATIVE_PHONE: '',
      ALTERNATIVE_PHONE_EXT: 0,
      DEPARTMENT_ID: formModel.DEPARTMENT_ID || '',
      REPORT_TO_ID: '',
      PASSWORD: '',
      EXTERNAL_USER_ORGANIZATION: '',
      DEFAULT_ID: '',
      DEFAULT_DEPARTMENT_ID: '',
      AUTHTYPE: '',
      CreatedUserType:'SUPERADMIN',
      isChecked: false,
      Status: formModel.Status,
      IsAdmin:formModel.IsAdmin,
      ROLEID: formModel.ROLEID ||'',
      ORGANIZATION_ID: this.Content.content.OrgId,
    };

    return user;
  }
 
  save() {
    if (this.validateControls()) {
 
      if (this.Content.heading === 'Add') {
        this.summaryService.addUserSummary(this.getForm()).subscribe(result => {
          if (result.Status === 0) {
            this.commonservice.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else {
             this.commonservice.ValidationBanner(result.Message);
          }
        });

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.editUserSummary(this.getForm()).subscribe(result => {
          if (result.Status === 0) {
            this.commonservice.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })
      }
    }
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.userForm.getRawValue();
    //debugger;

    if (formData.TITLE === null || formData.TITLE === "") {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Username <br/>";
      isValid = false;
    } else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message += "Please enter Email ID <br/>";
      isValid = false;
    } else {
      let isValidEmail  =this.commonservice.validateEmail(formData.EMAIL);
      if (isValidEmail) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += "Please enter valid  Email ID <br/>";
        isValid = false;
      }
    }

    // if (formData.PHONE === null || formData.PHONE === "") {
    
    // } else {
    //   //const phoneformat = /^[0-9]\d*$/;
    //   let isphno = this.commonservice.validatePhoneNo(formData.PHONE);
    //   //const mailformat = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
    //   if (isphno) {
    //     $("#PHONE").addClass("ng-untouched ng-valid");
    //     $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#PHONE").addClass("ng-touched ng-invalid validate-error");
    //     $("#PHONE").removeClass("ng-untouched ng-valid");
    //     message += "Please enter valid Phone <br/>";
    //     isValid = false;
    //   }
    // }
   
    if (!isValid)
    this.commonservice.ValidationBanner(message);
    return isValid;
  }

}
